export default {
  ACTIVITIES: "Activities",
  VIDEOS: "Videos",
  BLOG_POSTS: "Blog Posts",
};
